// Module
var code = "<div id=\"admin-server-details\">\r\n  <div data-bind=\"visible: announcementContent\">\r\n    <div data-bind=\"html: announcementContent\"></div>\r\n  </div>\r\n\r\n  <div data-bind=\"html: pageContent\">\r\n  </div>\r\n\r\n</div>\r\n";
// Exports
module.exports = code;